"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = require("./constants");
var owa_sharing_strings_1 = require("owa-strings/owa-sharing-strings");
function createSharingMessageActionText(action) {
    switch (action) {
        case Constants.ACCEPT_AND_VIEW_CALENDAR:
            // In React, accepting sharing message is broken into two actions, an "Accept" and then a
            // "View Calendar". So the "Accept and view calendar" button no longer makes sense, so we'll default to
            // just "Accept" instead.
            return owa_sharing_strings_1.default.acceptAcceptButtonText;
        case Constants.ADD_THIS_CALENDAR:
            return owa_sharing_strings_1.default.addThisCalendarAcceptButtonText;
        case Constants.VIEW_CALENDAR:
            return owa_sharing_strings_1.default.viewCalendarAcceptButtonText;
        default:
            /*CalendarSharingAction.Accept is the old default value*/
            return owa_sharing_strings_1.default.acceptAcceptButtonText;
    }
}
exports.default = createSharingMessageActionText;
//# sourceMappingURL=createSharingMessageActionText.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/utils/createSharingMessageActionText.js
// module id = 5803
// module chunks = 96